export default "__VITE_ASSET__UXY4MXgC__"